Object.defineProperty(exports, "__esModule", { value: true });
var SharedUtils_1 = require("../utils/SharedUtils");
var CRM = (function () {
    function CRM(targetDivId, sourceDivId, callback) {
        this.targetDivId = targetDivId;
        this.sourceDivId = sourceDivId;
        this.callback = callback;
        this._maxParallelRequests = 5;
        this._runningRequestCount = 0;
        this._loaderActive = false;
        this._nextUpdateURL = null;
        this._cacheQueue = [];
        this._reqData = {};
        this.sourceDivId = sourceDivId || targetDivId;
    }
    CRM.prototype.getPage = function (URL, callback, update) {
        var _this = this;
        if (update === void 0) { update = true; }
        this._runningRequestCount++;
        this._reqData[URL] = { loading: true };
        this._reqData[URL].request = SharedUtils_1.request({
            url: URL,
            method: 'get',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
            .then(function (res) {
            _this.onResponse(res.text, URL, callback);
        })
            .catch(function (err) {
            _this.removeLoader();
            console.warn('Async content load request failed.');
        })
            .then(function (res) { return _this.processCacheQueue(); });
    };
    CRM.prototype.onResponse = function (textHTML, URL, callback) {
        this._reqData[URL].head = textHTML.substring(textHTML.indexOf('<head'), textHTML.indexOf('</head>') + 7);
        this._reqData[URL].body = textHTML.substring(textHTML.indexOf('<body'), textHTML.indexOf('</body>') + 7);
        this._reqData[URL].cached = true;
        this._reqData[URL].loading = false;
        this._nextUpdateURL === URL && this.update(URL, callback);
    };
    CRM.prototype.extractAndExecuteScripts = function (node) {
        var scripts = Array.prototype.slice.call(node.getElementsByTagName('script'));
        var limit = scripts.length;
        for (var index = 0; index < limit; index++) {
            if (scripts[index].src != '') {
                var tag = document.createElement('script');
                tag.src = scripts[index].src;
                document.getElementsByTagName('head')[0].appendChild(tag);
            }
        }
    };
    CRM.prototype.update = function (URL, callback) {
        var headNode = document.createElement('head');
        headNode.innerHTML = this._reqData[URL]['head'];
        this.processHeadTags(headNode);
        var bodyNode = document.createElement('body');
        bodyNode.innerHTML = this._reqData[URL]['body'];
        this.processContentTags(bodyNode);
        this._loaderActive = false;
        this._nextUpdateURL = null;
        callback && callback();
        this.callback && this.callback();
    };
    CRM.prototype.processHeadTags = function (headNode) {
        var selectorCN = "link[rel='canonical']";
        var newCanonicalNode = headNode.querySelector(selectorCN);
        var newValueCN = newCanonicalNode ? newCanonicalNode.getAttribute('href') : null;
        var oldCanonicalNode = document.head.querySelector(selectorCN);
        if (newValueCN) {
            if (oldCanonicalNode) {
                oldCanonicalNode.setAttribute('href', newValueCN);
            }
            else {
                document.head.appendChild(newCanonicalNode);
            }
        }
        else {
            oldCanonicalNode && oldCanonicalNode.parentNode.removeChild(oldCanonicalNode);
        }
        var newHeadNodes = [];
        for (var index = 0; index < headNode.children.length; index++) {
            newHeadNodes.push(headNode.children[index]);
        }
        for (var index = 0; index < newHeadNodes.length; index++) {
            if (newHeadNodes[index].tagName !== 'META' && newHeadNodes[index].tagName !== 'TITLE') {
                newHeadNodes[index].parentNode.removeChild(newHeadNodes[index]);
            }
        }
        var oldHeadNodes = [];
        for (var index = 0; index < document.head.children.length; index++) {
            oldHeadNodes.push(document.head.children[index]);
        }
        for (var index = 0; index < oldHeadNodes.length; index++) {
            if (oldHeadNodes[index].tagName === 'META' || oldHeadNodes[index].tagName === 'TITLE') {
                oldHeadNodes[index].parentNode.removeChild(oldHeadNodes[index]);
            }
        }
        var nodesToAppend = [];
        for (var index = 0; index < headNode.children.length; index++) {
            nodesToAppend.push(headNode.children[index]);
        }
        for (var index = 0; index < nodesToAppend.length; index++) {
            document.head.appendChild(nodesToAppend[index]);
        }
    };
    CRM.prototype.processContentTags = function (node) {
        var targetNode = document.querySelector('#' + this.targetDivId);
        var sourceNode = node.querySelector('#' + this.sourceDivId);
        targetNode.innerHTML = sourceNode.innerHTML;
        this.extractAndExecuteScripts(sourceNode);
    };
    CRM.prototype.addLoader = function () {
        var loaderNode = document.createElement('div');
        var targetNode = document.querySelector('#' + this.targetDivId);
        loaderNode.setAttribute('class', 'content-changer__loader');
        loaderNode.innerHTML =
            '<div class="w--spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
        targetNode.insertBefore(loaderNode, targetNode.firstChild);
        this._loaderActive = true;
    };
    CRM.prototype.removeLoader = function () {
        var loaderNode = document.querySelector('#' + this.targetDivId + ' .content-changer__loader');
        loaderNode && loaderNode.parentNode.removeChild(loaderNode);
    };
    CRM.prototype.processCacheQueue = function () {
        while (this._cacheQueue.length > 0 && this._maxParallelRequests > this._runningRequestCount) {
            this.getPage(this._cacheQueue.shift());
        }
    };
    CRM.prototype.getURLData = function (URL) {
        return this._reqData[URL || window.location.pathname];
    };
    CRM.prototype.isInQueue = function (URL, priortize) {
        if (priortize === void 0) { priortize = true; }
        var index = this._cacheQueue.indexOf(URL);
        if (priortize && index > 0) {
            this._cacheQueue.splice(index, 1);
            this._cacheQueue.unshift(URL);
        }
        return index >= 0;
    };
    CRM.prototype.isCached = function (URL) {
        var URLData = this.getURLData(URL);
        return URLData && URLData.cached;
    };
    CRM.prototype.isLoading = function (URL) {
        var URLData = this.getURLData(URL);
        return URLData && URLData.loading;
    };
    CRM.prototype.cache = function (URLS) {
        for (var key in URLS) {
            this._reqData[URLS[key]] === undefined && this._cacheQueue.push(URLS[key]);
        }
        this.processCacheQueue();
    };
    CRM.prototype.load = function (URL, onAfterLoad, forceRefresh) {
        if (forceRefresh === void 0) { forceRefresh = false; }
        this._nextUpdateURL = URL = URL || window.location.pathname;
        if (!this._loaderActive)
            this.addLoader();
        if (this.isLoading(URL) || this.isInQueue(URL))
            return;
        this.isCached(URL) && !forceRefresh ? this.update(URL, onAfterLoad) : this.getPage(URL, onAfterLoad);
    };
    return CRM;
}());
exports.default = CRM;
